import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, GoogleDriveIntegration } from 'api/clients/ExternalIntegrationsClient'
import { GoogleDrive } from 'blaze-ui/icons'
import { CardButtons } from './CardButtons'
import { useModals } from 'almanac-ui/Modal'
import { GoogleDriveInitialization } from 'components/IntegrationInitialization'
import { GoogleDriveSettingsModal } from '../GoogleDriveSettingsModal/GoogleDriveSettingsModal'
import { useGoogleDriveIntegration } from 'hooks/useGoogleDriveIntegration'

export const GoogleDriveCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: GoogleDriveIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()
  const { needsReauth } = useGoogleDriveIntegration()

  const isConnected = integrations.length > 0
  const showSettings = isConnected && !isDisconnected
  const integration = integrations[0]

  return (
    <ExternalIntegrationCard
      title="Google Drive"
      description="Import brand assets, documents, and images from Google Drive"
      integrations={integrations}
      icon={<GoogleDrive size={20} />}
      isDisconnected={isDisconnected}
      isOutdated={needsReauth}
      onSettingsPress={showSettings ? () => openModal(GoogleDriveSettingsModal, { integration }) : undefined}
      buttons={
        <CardButtons
          onConnect={() => openModal(GoogleDriveInitialization)}
          provider={ExternalIntegrationEnum.GoogleDrive}
          isConnected={isConnected}
          integration={integration}
          isDisconnected={isDisconnected}
          isOutdated={needsReauth}
        />
      }
    />
  )
}
